import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom'
import { ProblemNewMobile } from '@/public/features/problem/ui/ProblemNewMobile'
import { ProblemNewModalPc } from '@/public/features/problem/ui/ProblemNewModalPc'
import { TOTAL_STEPS } from '@/public/features/problem/constants/problemNew'
import {
  problemFlowBasePath,
  useProblemNewDraft,
  type ProblemEditTarget,
} from '@/public/features/problem/composables/problemNewDraft'

export function ProblemNewFlowPage({ closeTo }: { closeTo?: string }) {
  const { pathname } = useLocation()
  const { id } = useParams()
  const [params] = useSearchParams()
  const token = params.get('t')

  const edit: ProblemEditTarget | undefined =
    id !== undefined && token !== null ? { id, token } : undefined
  const basePath = problemFlowBasePath(edit)
  const step = readStep(pathname, basePath)
  const draft = useProblemNewDraft(step ?? 1, edit)

  const query = token === null ? '' : `?t=${encodeURIComponent(token)}`

  if (step === null) return <Navigate to={`${basePath}${query}`} replace />

  // 수정 폼을 받아오는 동안에는 값이 비어 있어 1단계로 되돌려진다.
  if (draft.isLoadingForm) return null

  // TODO 404(링크 무효·카드 없음) · 409(운영자가 중단·만료) 화면 문구 미정 — 지금은 조용히 지나간다.
  if (draft.formError !== null && draft.formError !== undefined) return null

  if (step > draft.firstIncompleteStep) {
    const to = draft.firstIncompleteStep
    return <Navigate to={`${basePath}${to <= 1 ? '' : `/${to}`}${query}`} replace />
  }

  if (closeTo !== undefined) return <ProblemNewModalPc draft={draft} closeTo={closeTo} />

  return <ProblemNewMobile draft={draft} />
}

function readStep(pathname: string, basePath: string): number | null {
  const tail = pathname.replace(new RegExp(`^${basePath}/?`), '')
  if (tail === '') return 1
  const n = Number(tail)
  if (!Number.isInteger(n) || n < 2 || n > TOTAL_STEPS) return null
  return n
}
